import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import CarouselThumb from './CarouselThumb';

const CarouselThumbs = ({
  selection,
  deal,
  thumbWidth,
  thumbCount,
  onSelect,
  invert,
}) => {
  const [offset, setOffset] = useState();
  const ref = useRef();

  useEffect(() => {
    if (ref.current && deal.images) {
      const calcLeftOffset = () => {
        const wrapperWidth = ref.current.clientWidth - 6;
        const thumbWidthWithBorder = thumbWidth + 18;
        const widthOfAllThumbs = thumbWidthWithBorder * deal.images.length;
        const thumbsOnPage = Math.floor(wrapperWidth / thumbWidthWithBorder);
        const middle = Math.floor(wrapperWidth / thumbWidthWithBorder / 2);
        const max = widthOfAllThumbs - wrapperWidth;

        if (deal.images.length > thumbsOnPage && selection > middle) {
          const left = (selection - middle) * thumbWidthWithBorder;
          if (left > max) {
            setOffset(max);
          } else {
            setOffset(left);
          }
        } else {
          setOffset(0);
        }
      };
      calcLeftOffset();
      window.addEventListener('resize', calcLeftOffset, { passive: true });

      return () => {
        window.removeEventListener('resize', calcLeftOffset);
      };
    }

    return null;
  }, [deal.images, selection, thumbWidth]);

  return (
    <>
      <div className="thumbs" ref={ref}>
        <ul className="thumbs__wrapper">
          {deal.images?.map((image, index) => {
            return (
              <CarouselThumb
                deal={deal}
                image={image}
                index={index}
                invert={invert}
                key={`thumb_${deal.id}_${index}}`}
                onSelect={onSelect}
                selected={selection === index}
                thumbWidth={thumbWidth}
              />
            );
          })}
        </ul>
      </div>
      <style jsx>{`
        .thumbs {
          position: absolute;
          bottom: 38px;
          left: 0;
          overflow: hidden;
          width: ${thumbCount &&
          (thumbWidth + 18) * thumbCount +
            6 +
            'px'}; // (thumbWidth + thumb padding/margin) * thumbCount + wrapper padding
        }
        .thumbs__wrapper {
          padding: 3px;
          margin: 0;
          white-space: nowrap;
          transition: transform 0.4s;
          transform: translate3d(-${offset}px, 0, 0);
        }
        @media (prefers-reduced-motion) {
          .thumbs__wrapper {
            transition: none;
          }
        }
      `}</style>
    </>
  );
};

CarouselThumbs.propTypes = {
  deal: PropTypes.object,
  invert: PropTypes.bool,
  onSelect: PropTypes.func,
  selection: PropTypes.number,
  thumbCount: PropTypes.number,
  thumbWidth: PropTypes.number,
};

CarouselThumbs.defaultProps = {
  deal: {},
  invert: false,
  onSelect: () => false,
  selection: 0,
  thumbCount: undefined,
  thumbWidth: 54,
};

export default CarouselThumbs;
